export const isCustomerTypeProfessional = (
  customerType: string | undefined
): boolean => {
  return !!(customerType && customerType === 'professional')
}
